import type { Widget } from '@/types';
import {
  LinkWidget,
  TextWidget,
  PhotoWidget,
  ProductWidget,
  SocialWidget,
  MusicWidget,
  VoiceWidget,
  OneLinkWidget,
  ContentWidget,
} from '@/components/widgets';

interface WidgetRendererProps {
  widget: Widget;
  preview?: boolean;
  userId?: string;
}

const WidgetRenderer = ({ widget, preview = false, userId }: WidgetRendererProps) => {
  switch (widget.type) {
    case 'link':
      return <LinkWidget data={widget.data as any} preview={preview} />;
    case 'text':
      return <TextWidget data={widget.data as any} />;
    case 'photo':
      return <PhotoWidget data={widget.data as any} />;
    case 'product':
      return <ProductWidget data={widget.data as any} preview={preview} />;
    case 'social':
      return <SocialWidget data={widget.data as any} preview={preview} />;
    case 'music':
      return <MusicWidget data={widget.data as any} />;
    case 'voice':
      return <VoiceWidget data={widget.data as any} />;
    case 'onelink':
      return <OneLinkWidget data={widget.data as any} />;
    case 'content':
      return <ContentWidget data={widget.data as any} userId={userId} />;
    default:
      return null;
  }
};

export default WidgetRenderer;
